import StoreDeliveryPossibleArea from '@/entity/StoreDeliveryPossibleArea';
import { getFullTextOfArea, isSameDong, } from '@/vuex-store/store-delivery-possible-area/getterUtil';
const getters = {
    /** 등록 가능한 동 데이터 구조 통일 */
    flattenGaiaDongList: ({ eupMyeonDongList, selectedSiDo, selectedSiGunGu, }) => new StoreDeliveryPossibleArea(selectedSiDo?.name, selectedSiGunGu?.name, eupMyeonDongList.constantGroups).list,
    /** 등록 가능한 동 - register */
    flattenCalculatedGaiaDongList: ({ register, }, { flattenGaiaDongList, }) => flattenGaiaDongList
        .filter((dong) => !register.some((registerDong) => isSameDong(dong, registerDong))),
    /** 상점의 동 - register + unregister */
    flattenCalculatedStoreDongList: ({ storeDeliveryPossibleAreaList, register, unregister, }) => storeDeliveryPossibleAreaList
        .filter((dong) => !unregister.some((unregisterDong) => isSameDong(dong, unregisterDong)))
        .concat(register),
    /** (상점의 동 - register + unregister)을 Map으로 변환. */
    simpleStoreDongList: (state, { flattenCalculatedStoreDongList, }) => {
        const areaMap = new Map();
        flattenCalculatedStoreDongList.forEach((area) => {
            const text = getFullTextOfArea(area);
            areaMap.set(text, true);
        });
        return areaMap;
    },
    /** 상점의 동 데이터와 중복을 제거한 등록 가능한 동 리스트 */
    noDuplicatedGaiaDongList: (state, { flattenCalculatedGaiaDongList, simpleStoreDongList, }) => flattenCalculatedGaiaDongList.filter((item) => {
        const text = getFullTextOfArea(item);
        return !simpleStoreDongList.has(text);
    }),
    sortedGaiaDongList: (state, { noDuplicatedGaiaDongList, }) => noDuplicatedGaiaDongList
        .sort((a, b) => getFullTextOfArea(a).localeCompare(getFullTextOfArea(b))),
    sortedStoreDongList: (state, { flattenCalculatedStoreDongList, }) => flattenCalculatedStoreDongList
        .sort((a, b) => getFullTextOfArea(a).localeCompare(getFullTextOfArea(b))),
    finalGaiaDongLength: (state, { sortedGaiaDongList, }) => sortedGaiaDongList.length,
    finalStoreDongLength: (state, { sortedStoreDongList, }) => sortedStoreDongList.length,
    getterIsChanged: ({ register, unregister, }) => !!register.length || !!unregister.length,
};
export default getters;
